<div [formGroup]="formFinancialDetails">
  <h2>Financial Details</h2>
  <div class="financial-details__container financial-details__container--with-wizard-buttons">
    <p class="financial-details__info">This Section relates to Contact details for billing purposes.</p>
    <button class="financial-details__button--copy" mat-raised-button (click)="copyGeneralToFinancial()">Copy from General Details</button>

    <div class="financial-details__grid">
      <div>
        <mat-form-field>
          <mat-label>Select Salutation</mat-label>
          <mat-select title="Standard select" formControlName="salutation">
            <mat-option>--</mat-option>
            @for (salutation of salutations; track salutation) {
              <mat-option [value]="salutation.value"> {{ salutation.value }} </mat-option>
            }
          </mat-select>
          <mat-error>Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" />
          <mat-error> Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName" />
          <mat-error> Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Email address</mat-label>
          <mat-icon
            matSuffix
            matTooltip="This email address will used for correspondence regarding licences/permits and for the management of your eLicensing account."
            matTooltipPosition="above"
            >help_outline</mat-icon
          >
          <input matInput formControlName="email" />
          <mat-error comFormMessageName="email" validation="required">Required</mat-error>
          <mat-error comFormMessageName="email" validation="pattern">The email format is incorrect</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Phone</mat-label>
          <input matInput formControlName="phone" />
          <mat-error> Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Mobile</mat-label>
          <input matInput formControlName="mobile" />
        </mat-form-field>
      </div>

      <div>
        <mat-checkbox formControlName="electronicInvoicing">Electronic Invoicing</mat-checkbox>
      </div>
    </div>

    <div class="financial-details__grid">
      <div>
        <mat-form-field>
          <mat-label>Address Line 1</mat-label>
          <input matInput formControlName="addressLine1" />
          <mat-error> Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Address Line 2</mat-label>
          <input matInput formControlName="addressLine2" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Address Line 3</mat-label>
          <input matInput formControlName="addressLine3" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Address Line 4</mat-label>
          <input matInput formControlName="addressLine4" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Postcode</mat-label>
          <input matInput formControlName="postCode" />
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Select county</mat-label>
          <mat-select title="Standard select" formControlName="county">
            <mat-option>--</mat-option>
            @for (county of counties; track county) {
              <mat-option [value]="county.value"> {{ county.value }} </mat-option>
            }
          </mat-select>
          <mat-error>Required</mat-error>
        </mat-form-field>
      </div>

      <div>
        <mat-form-field>
          <mat-label>Select country</mat-label>
          <mat-select (selectionChange)="countryChanged($event.value)" title="Standard select" formControlName="country">
            <mat-option>--</mat-option>
            @for (country of countries; track country) {
              <mat-option [value]="country.name"> {{ country.name }} </mat-option>
            }
          </mat-select>
          <mat-error>Required</mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
